import React, { useCallback } from 'react';
import { Button } from '@qualtrics/ui-react';
import { messageService } from '../../../Service/message-service';
import { useAccountService } from '../../../Context';
import styles from './EmailVerificationRejectedInfo.scss';

type EmailVerificationRejectedInfoProps = {
  additionalAttributes?: string[];
};

export const EmailVerificationRejectedInfo = ({
  additionalAttributes,
}: EmailVerificationRejectedInfoProps) => {
  const { accountActionsService } = useAccountService();
  const reason = additionalAttributes?.[1];

  const onReloginClick = useCallback(() => {
    accountActionsService.logout();
  }, [accountActionsService]);

  return (
    <>
      <div>{messageService.get('EMAIL_VERIFICATION_REJECTED_DESCRIPTION')}</div>
      {reason ? (
        <div className={styles.reason}>
          <strong>
            {messageService.get('EMAIL_VERIFICATION_REJECTED_REASON_LABEL')}
          </strong>{' '}
          &quot;{reason}&quot;
        </div>
      ) : null}
      <Button
        kind="link"
        onClick={onReloginClick}
        className={styles.link}
        data-testid="email-verification-relogin-link"
      >
        {messageService.get('RELOGIN_NOW')}
      </Button>
    </>
  );
};
